import React from "react";
import { Col, Row, Select } from "antd";
import "./TablePageSelect.less";
import { v4 as uuid } from "uuid";

const TablePageSelect = ({ pageSizeOptions, onChange, value, disabled = false }) => (
  <>
    <Row align="middle" wrap={false}>
      <Col style={{ lineHeight: 1.2, marginRight: "7px", color: "#5D6C7A" }}>
        Кол-во записей на странице
      </Col>
      <Col>
        <Select value={value} onChange={onChange} disabled={disabled}>
          {Object.keys(pageSizeOptions).map((key) => (
            <Select.Option key={uuid()} value={pageSizeOptions[key]}>
              {key}
            </Select.Option>
          ))}
        </Select>
      </Col>
    </Row>
  </>
);

export default TablePageSelect;
